import React, { useEffect, useMemo, useState } from 'react';

import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';
import { GetMemberService } from '../../services/core/getMemberService';
import { GetLaunchdarkly, ICrossSell } from '../../services/launchdarkly';

import { crossSellActions } from '../../store/duck';
import Tooltip from '../Tooltip';
import Checkbox from './components/Checkbox';

interface Member {
  isClubMember: boolean;
  category: 'smiles' | 'prata' | 'ouro' | 'diamante' | '';
}

export const SESSION_STORAGE_CROSS_SELL = '@smiles/cross-sell';

const CrossSell = ({ ...props }) => {
  const [member, setMember] = useState<Member>({
    isClubMember: false,
    category: '',
  });

  const [launchdarklyData, setLaunchdarlyData] = useState<ICrossSell | null>(null);
  const isMobile = window.innerWidth < 839
  const isCrossSellChecked = useAppSelector(({ crossSell }) => crossSell.isChecked);

  const isSafariUserAGent = /Apple/.test(navigator.vendor);

  const dispatch = useAppDispatch();

  const isEnableCheckBox = useMemo(() => {
    // reset redux state
    dispatch(crossSellActions.setIsCrossSellChecked(false));

    // Indicates that this page came from flights-search
    const isCrossSellFlow = new URLSearchParams(window.location.search).get('crossSell') === 'true';
    window.sessionStorage.setItem(SESSION_STORAGE_CROSS_SELL, JSON.stringify(isCrossSellFlow));

    if (isSafariUserAGent && isMobile) {
      return false;
    }

    // Disable by general property and if the member is club and isn't enabled club
    if (!launchdarklyData || !launchdarklyData.enableAll || (member.isClubMember && !launchdarklyData.enableClub)) {
      return false;
    }

    // Disable by device
    const { desktop, mobile } = launchdarklyData.device;
    if ((!isMobile && !desktop) || (isMobile && !mobile)) {
      return false;
    }

    // Disable by category tier
    const category = member.category.toLowerCase();
    const crossSellTiers = launchdarklyData.tier;
    const tiersEnabled = Object.keys(crossSellTiers).filter((tier) => crossSellTiers[tier as keyof ICrossSell['tier']]);

    if (member.category && !tiersEnabled.includes(category)) {
      return false;
    }

    dispatch(crossSellActions.setIsCrossSellChecked(true));

    return true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [launchdarklyData, member, isMobile, isSafariUserAGent]);

  const onGetLaunchdarkly = async () => {
    const response = await GetLaunchdarkly.execute();

    if (response) {
      setLaunchdarlyData(response);
    }
  };

  const onFetchData = async () => {
    const response = await GetMemberService.execute();

    if (response?.data) {
      setMember(response.data as Member);
    }

    await onGetLaunchdarkly();
  };

  useEffect(() => {
    onFetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isEnableCheckBox) {
    return null;
  }

  return (
    <div className="cross-sell-container" {...props}>
      <Checkbox
        id="cross-sell-checkbox-hotel"
        name="cross-sell-checkbox-hotel"
        isChecked={isCrossSellChecked}
        onCheck={() => dispatch(crossSellActions.setIsCrossSellChecked(!isCrossSellChecked))}
        className="smls-cross-sell-checkbox"
      />

      <span className="cross-sell-description">
        Incluir busca por carros
        <Tooltip
          position="top-right"
          text="Abre nova aba de busca"
          containerClassName="cross-sell-description-tooltip"
          tooltipClassName="hotels-search-panel-cross-sell-tooltip"
        >
          <i className="cross-sell-description-tooltip-icon material-icons-outlined">info</i>
        </Tooltip>
      </span>
    </div>
  );
};

export default CrossSell;
